const DisplayDigits = ({ digits }) => {
  return (
    <div className="is-flex is-flex-direction-row">
      <div className="has-border-purple-2 mr-1">
        <div style={{ width: "20px", textAlign: "center" }}>
          {digits.toString().length === 1 ? 0 : digits.toString().charAt(0)}
        </div>
      </div>
      <div className="has-border-purple-2">
        <div style={{ width: "20px", textAlign: "center" }}>
          {digits.toString().length === 2 ? digits.toString().charAt(1) : digits.toString()}
        </div>
      </div>
    </div>
  );
};

export default DisplayDigits;
